import {
  hasStoryAccess as hasStoryAccessApi,
  incrementPremiumStoriesRead as incrementPremiumStoriesReadCountApi
} from "./api";
import { isPremium } from "./data/story";

function getStoriesReadFromLocalStorage() {
  if (global.localStorage) {
    return JSON.parse(global.localStorage.getItem("premiumStoriesRead") || '{"storyIds": []}');
  }

  return {
    storyIds: []
  };
}

export function hasStoryAccess(story) {
  return new Promise((resolve, reject) => {
    if (!isPremium(story)) {
      resolve({ granted: true, grantReason: "FREE" });
    }

    global.userPromise.catch(() => null).then(user => {
      if (!user) {
        const storiesReadCount = getStoriesReadFromLocalStorage().storyIds.length;
        const storiesAlreadyRead = getStoriesReadFromLocalStorage().storyIds.includes(story.id)
          ? storiesReadCount
          : storiesReadCount + 1;
        const remainingStoriesCount = 4 - storiesAlreadyRead;
        return resolve({
          granted: getStoriesReadFromLocalStorage().storyIds.includes(story.id) || storiesReadCount < 4,
          grantReason: "METERING LOCAL",
          remainingStoriesCount: remainingStoriesCount < 0 ? 0 : remainingStoriesCount
        });
      }

      hasStoryAccessApi(story.id)
        .then(resolve)
        .catch(reject);
    });
  });
}

export function incrementPremiumStoriesRead(storyId) {
  if (global.localStorage) {
    if (!storyId) {
      const storiesAlreadyRead = getStoriesReadFromLocalStorage();
      return incrementPremiumStoriesReadCountApi(storiesAlreadyRead.storyIds);
    }
    const currentDate = new Date();
    let alreadyViewedStories = new Set([]);
    const storiesAlreadyRead = getStoriesReadFromLocalStorage();
    if (storiesAlreadyRead.expiresAt > currentDate.valueOf()) {
      alreadyViewedStories = new Set(storiesAlreadyRead.storyIds);
    }
    alreadyViewedStories.add(storyId);
    global.localStorage.setItem(
      "premiumStoriesRead",
      JSON.stringify({
        storyIds: Array.from(alreadyViewedStories),
        expiresAt: new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1).valueOf()
      })
    );
    return incrementPremiumStoriesReadCountApi(storyId);
  }
}
